import React from 'react';
import { Modal, Form, FormInstance } from 'antd';
import { CounterpartyAgreementDtoRequest } from '../../../../interfaces/CounterpartyDtos';
import CounterpartyAgreementForm from './CounterpartyAgreementForm';

interface CounterpartyModalProps {
    visible: boolean;
    type: 'add' | 'edit';
    parentForm?: FormInstance<any>;
    onClose: () => void;
    onSubmit: (values: CounterpartyAgreementDtoRequest) => void;
}

const CounterpartyAgreementModal: React.FC<CounterpartyModalProps> = ({ visible, type, onClose, onSubmit, parentForm }) => {
    const [form] = Form.useForm();

    const customForm = parentForm ? parentForm : form;

    const handleOk = () => {
        customForm.submit();
    };

    return (
        <Modal
            title={type === 'add' ? 'Добавление соглашения' : 'Редактирование соглашения'}
            open={visible}
            onOk={handleOk}
            onCancel={onClose}
            okText="Добавить"
            cancelText="Отмена"
            width="50%"
            maskClosable={true}
        >
            <CounterpartyAgreementForm form={customForm} onFinish={onSubmit} />
        </Modal>
    );
};

export default CounterpartyAgreementModal;